import { render, staticRenderFns } from "./ExamStudentSpeaking.vue?vue&type=template&id=0bb36dfe&scoped=true"
import script from "./ExamStudentSpeaking.vue?vue&type=script&lang=js"
export * from "./ExamStudentSpeaking.vue?vue&type=script&lang=js"
import style0 from "./ExamStudentSpeaking.vue?vue&type=style&index=0&id=0bb36dfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb36dfe",
  null
  
)

export default component.exports